import React, { useCallback, useEffect } from "react";
import {
  StyleProp,
  ViewStyle,
  ScrollView,
  View,
  Text,
  StyleSheet,
} from "react-native";
import { ImageCarouselAdd, ImageCarouselImage } from "./components";
import { colors } from "src/assets";
import { EventRegister } from "react-native-event-listeners";
import { navigationRef } from "src/hooks/navigation";

export type ImageCarouselProps = {
  style?: StyleProp<ViewStyle>;
  images?: string[];
  error?: string;
  onAdd?: (imageUrl: string) => void;
  onDelete?: (index: number) => void;
};

export const ImageCarousel: React.FC<ImageCarouselProps> = ({
  style,
  images,
  error,
  onAdd,
  onDelete,
}) => {
  useEffect(() => {
    const listener = EventRegister.addEventListener("OfferEditImage", (e) => {
      if (onAdd) {
        onAdd(e.dataURL);
      }
    });
    return () => {
      EventRegister.removeEventListener(listener as string);
    };
  }, [onAdd]);
  const onImageUpload = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target?.files?.[0]) {
        navigationRef.current?.navigate("CustomImageCrop", {
          eventName: "OfferEditImage",
          file: event.target?.files?.[0],
          // maxSize: {
          //   width: 375 * 2,
          //   height: 280 * 2,
          // },
        });
      }
      event.target.value = "";
    },
    []
  );
  const onDeleteAction = useCallback(
    (index: number) => {
      if (onDelete) {
        onDelete(index);
      }
    },
    [onDelete]
  );
  return (
    <React.Fragment>
      <View style={styles.container}>
        <input
          id="image-upload"
          type="file"
          onChange={onImageUpload}
          accept="image/*"
          style={{ display: "none" }}
        />
        <ScrollView
          style={style}
          horizontal={true}
          pagingEnabled={true}
          showsHorizontalScrollIndicator={false}
        >
          {images?.map((image, index) => (
            <ImageCarouselImage
              key={index}
              index={index + 1}
              image={image}
              onDelete={() => onDeleteAction(index)}
            />
          ))}
          <label htmlFor="image-upload">
            <ImageCarouselAdd index={(images?.length || 0) + 1} />
          </label>
        </ScrollView>
        {error ? <Text style={styles.error}>{error}</Text> : null}
      </View>
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  error: {
    color: colors.chokuRed,
    marginHorizontal: 16,
  },
});
